import React from "react";
import { Form } from "react-final-form";
import { Col, Row } from "reactstrap";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import { IApplicationInsured } from "src/store/models/application.model";
import * as S from "../../../../constants/StringConstants";
import "./AddInsuredModal.scss";

interface AddInsuredModalProps {
  open: boolean;
  handleConfirm: (values) => void;
  handleReject: () => void;
  insuredDetails: IApplicationInsured;
}

export const AddInsuredModal = ({ open, handleConfirm, handleReject, insuredDetails }: AddInsuredModalProps) => {
  const onSubmit = (values: Partial<IApplicationInsured>) => {
    handleConfirm(values);
  };

  return (
    <Form
      initialValues={insuredDetails}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <PromptModal
          open={open}
          title={S.APP_INSUREDS_MODAL_TITLE}
          confirmText={S.APP_INSUREDS_MODAL_CONFIRM}
          rejectText={S.APP_INSUREDS_MODAL_CANCEL}
          onReject={handleReject}
          onConfirm={handleSubmit}>
          <form onSubmit={handleSubmit} className="additional-insureds-modal__card_container">
            <Row>
              <Col sm={6}>
                <TextField name="firstName" label={S.APP_INSUREDS_MODAL_FIRST_NAME} />
              </Col>
              <Col sm={3}>
                <TextField name="middleName" label={S.APP_INSUREDS_MODAL_MI} />
              </Col>
              <Col sm={3}>
                <TextField name="suffix" label={S.APP_INSUREDS_MODAL_SUFFIX} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <TextField name="lastName" label={S.APP_INSUREDS_MODAL_LAST_NAME} />
              </Col>
              <Col sm={6}>
                <SimpleDatePickerField name="dob" label={S.APP_INSUREDS_MODAL_DOB} isFormMode showClear />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <TextField name="ssn" label={S.APP_INSUREDS_MODAL_SSN} />
              </Col>
              <Col sm={3}>
                <TypeaheadField
                  name="genderTypeID"
                  label={S.APP_INSUREDS_MODAL_GENDER}
                  options={insuredDetails?.selectGenderList}
                />
              </Col>
              <Col sm={3}>
                <TextField name="issueAge" label={S.APP_INSUREDS_MODAL_AGE} />
              </Col>
            </Row>

            <Row>
              <Col>
                <TextField name="faceAmount" label={S.APP_INSUREDS_MODAL_FACE_AMOUNT} />
              </Col>
              <Col>
                <TextField name="benefit" label={S.APP_INSUREDS_MODAL_BENEFIT} />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <TextField name="tableRatingPercent" label={S.APP_INSUREDS_MODAL_TABLE_RATING_PERCENT} />
              </Col>
              <Col sm={6}>
                <TypeaheadField
                  name="habitID"
                  label={S.APP_INSUREDS_MODAL_TOBACCO}
                  options={insuredDetails?.selectHabitList}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <TextField name="class" label={S.APP_INSUREDS_MODAL_CLASS} />
              </Col>
            </Row>
          </form>
        </PromptModal>
      )}
    />
  );
};
